const Plus = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-plus"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-plus"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M17,11H13V7a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v4H7a1,1,0,0,0-1,1H6a1,1,0,0,0,1,1h4v4a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V13h4a1,1,0,0,0,1-1h0A1,1,0,0,0,17,11Z" />
    </svg>
  );
};

// <path d="M16.5,10.5h-3v-3a1.5,1.5,0,0,0-3,0v3h-3a1.5,1.5,0,0,0,0,3h3v3a1.5,1.5,0,0,0,3,0v-3h3a1.5,1.5,0,0,0,0-3Z" />
export default Plus;
